<script setup>
import CustomLink from '../Components/CustomLink.vue'
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { Dialog, DialogPanel, TransitionChild, TransitionRoot, } from '@headlessui/vue'
import Button from '../Components/Button.vue';

const sidebarOpen = ref(false)
const showNavbar = ref(true)
let lastScrollPosition = 0

// Function to handle scrolling behavior
const onScroll = () => {
    const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
    if (currentScrollPosition < 0) return

    // Show or hide navbar based on scroll direction
    showNavbar.value = currentScrollPosition < lastScrollPosition
    lastScrollPosition = currentScrollPosition
}

// Add scroll event listener on mount and remove on unmount
onMounted(() => {
    window.addEventListener('scroll', onScroll)
})

onBeforeUnmount(() => {
    window.removeEventListener('scroll', onScroll)
})
</script>

<template>
    <div class="flex items-center fixed z-30 justify-center h-16 w-full border-black lg:hidden shadow-lg -mt-1 pt-1">
        <TransitionRoot as="template" :show="sidebarOpen">
            <Dialog as="div" class=" lg:hidden" @close="sidebarOpen = false">
                <TransitionChild as="template" enter="transition-opacity ease-linear duration-300"
                    enter-from="opacity-0" enter-to="opacity-100" leave="transition-opacity ease-linear duration-300"
                    leave-from="opacity-100" leave-to="opacity-0">
                    <div class="fixed inset-0 bg-gray-900/80" />
                </TransitionChild>

                <div class="fixed inset-0 z-20">
                    <TransitionChild as="template" enter="transition ease-in-out duration-300 transform"
                        enter-from="-translate-y-full" enter-to="translate-y-0"
                        leave="transition ease-in-out duration-300 transform" leave-from="translate-y-0"
                        leave-to="-translate-y-full">
                        <DialogPanel class="w-full">
                            <TransitionChild as="template" enter="ease-in-out duration-300" enter-from="opacity-0"
                                enter-to="opacity-100" leave="ease-in-out duration-300" leave-from="opacity-100"
                                leave-to="opacity-0">
                                <div>

                                </div>
                            </TransitionChild>
                            <!-- Sidebar component, swap this element with another sidebar if you like -->

                            <div class="bg-black h-lvh flex flex-col justify-between">
                                <header class=" flex items-center justify-between w-full bg-white relative">
                                    <div class="flex items-center justify-between p-3 w-full">
                                        <button type="button" class="bg-transparent text-gray-700 lg:hidden"
                                            @click="sidebarOpen = !sidebarOpen">
                                            <span class="sr-only">Open sidebar</span>
                                            <font-awesome-icon :icon="['far', 'bars']" v-if="!sidebarOpen"
                                                class="h-6 w-6" aria-hidden="true" />
                                            <font-awesome-icon :icon="['far', 'xmark']" v-if="sidebarOpen"
                                                class="h-6 w-6" aria-hidden="true" />
                                        </button>
                                        <div>
                                            <CustomLink href="/"><img class="h-10" :src="'/img/logo.webp'" @click="sidebarOpen = false"></CustomLink>
                                        </div>
                                        <div>
                                            <CustomLink class="primary-button" href="/overons" @click="sidebarOpen = false"> Contact </CustomLink>
                                        </div>
                                    </div>
                                </header>
                                <div class="flex flex-col gap-12">
                                    <div class="flex flex-col">
                                        <div class="grid text-white text-center gap-10">
                                            <CustomLink href="/aanbod" class="cursor-pointer text-lg hover:underline" @click="sidebarOpen = false">
                                                Aanbod</CustomLink>
                                            <CustomLink href="/services" @click="sidebarOpen = false"
                                                class="cursor-pointer text-lg hover:underline">Onderhoud & Services</CustomLink>
                                            <CustomLink href="/overons" class="cursor-pointer text-lg hover:underline" @click="sidebarOpen = false">
                                                Over ons</CustomLink>
                                            <CustomLink href="/overons#contactform" @click="sidebarOpen = false"
                                                class="cursor-pointer text-lg hover:underline">Contact</CustomLink>
                                        </div>
                                    </div>
                                    <div class="items-center flex flex-col gap-4 mx-6 ">

                                        <CustomLink :useInertia="false" target="_blank" href="https://wa.me/+31617328160" class="primary-button sm:w-full">
                                            <font-awesome-icon :icon="['fab', 'whatsapp']" class="h-5 w-5" />
                                            Whatsapp
                                        </CustomLink>
                                    </div>
                                </div>
                                <div class="flex gap-10 justify-center items-end pb-5">
                                    <CustomLink :useInertia="false" target="_blank" href="https://www.facebook.com/share/193ScDiQkB/?mibextid=wwXIfr">
                                        <font-awesome-icon :icon="['fab', 'facebook']" class="h-6 w-6 text-white" />
                                    </CustomLink>
                                    <CustomLink :useInertia="false" target="_blank" href="https://www.instagram.com/zwagersautomotive/">
                                        <font-awesome-icon :icon="['fab', 'instagram']" class="h-6 w-6 text-white" />
                                    </CustomLink>
                                </div>
                            </div>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </Dialog>
        </TransitionRoot>

        <!-- Static sidebar for desktop -->
        <header class="flex items-center justify-center w-full bg-white relative">
            <div class="flex items-center h-full p-3">
                <button type="button" class="bg-transparent text-gray-700 lg:hidden"
                    @click="sidebarOpen = !sidebarOpen">
                    <span class="sr-only">Open sidebar</span>
                    <font-awesome-icon :icon="['far', 'bars']" v-if="!sidebarOpen" class="h-6 w-6" aria-hidden="true" />
                    <font-awesome-icon :icon="['far', 'xmark']" v-if="sidebarOpen" class="h-6 w-6" aria-hidden="true" />
                </button>
            </div>
            <div class="flex items-center justify-center w-full">
                <CustomLink href="/"><img class="h-10 w-auto" :src="'/img/logo.webp'"></CustomLink>
            </div>
            <div class="flex justify-end p-3">
                <CustomLink href="/overons#contactform" class="secondary-black-button">Contact</CustomLink>
            </div>
        </header>
    </div>
    <div class="hidden lg:flex shadow-lg">
        <header class="flex justify-center w-full z-50 app">
            <nav class="z-50 shadow-lg md:rounded-lg bg-white ring-gray-100 ring-1 w-full mx-4 navbar items-center justify-between mt-5 fixed py-0.5 px-4 h-16 max-w-7xl border-black transition-all duration-300 grid grid-cols-3" :class="{ 'navbar--scrollanim': !showNavbar }">
                <CustomLink href="/" class="items-center"><img class="h-10" :src="'/img/logo.webp'" /></CustomLink>
                <div class="flex gap-8 justify-center">
                    <CustomLink href="/aanbod" class="button-animation hover:text-tan text-sm font-semibold">Aanbod</CustomLink>
                    <CustomLink href="/services" class="button-animation hover:text-tan text-sm font-semibold">Onderhoud & Services</CustomLink>
                    <CustomLink href="/overons" class="button-animation hover:text-tan text-sm font-semibold">Over ons</CustomLink>
                </div>
                <div class="flex gap-4 justify-end">
                    <!--TO WHATSAPP TEL:-->
                    <CustomLink href="https://wa.me/+31617328160" target="_blank" type="href" class="primary-button" :useInertia="false">
                        <font-awesome-icon :icon="['fab', 'whatsapp']" class="h-5 w-5" />
                        Whatsapp
                    </CustomLink>
                    <Button href="/overons#contactform" type="href" class="secondary-black-button">Contact</Button>
                </div>
            </nav>
        </header>
    </div>
</template>

<style>
.navbar {
    transition: 0.5s all ease-out;
}

.navbar.navbar--scrollanim {
    transform: translate3d(0, -20%, 0);
}
</style>